import { IAdminMinerTable, IAdminMinerTableOrig, IUnknownMinerOrig } from "@services/getMinerInfo";
import {
  GetAdminMinersList,
  GetUserMinersList,
  MTFiltersValuesI,
  MTSort,
  SortDirection,
} from "@services/getMinerList";
import { EmptyNamedTotals, MinerTabType } from "@services/http/responses/BaseResponse";
import { MinerRecordsResponse } from "@services/http/responses/BaseResponse";
import useApiRequests from "@services/http/useApiRequest";
import { RootState } from "@store";
import dbg from "@utils/dbg";
import { dev } from "@utils/dev";
import moment, { Moment } from "moment";
import { useSelector } from "react-redux";

export interface IUnknownMiner {
  // created, login, agent, ip, mac
  id: number;
  created: Moment;
  login: string;
  agent: string;
  ip: string;
  mac: string;
}

interface UnknownMinerDescr {
  created: number;
  login: string;
  agent: string;
  ip: string;
  mac?: string;
}

export type IAdminMinerTableWithUnknown = IAdminMinerTable | IUnknownMiner;

const useGetMinerList = () => {
  const { enqueue } = useApiRequests();
  const isAdmin = useSelector((state: RootState) => state.auth.isAdmin);

  const getMinerList = async (
    offset = 0,
    limit = 20,
    filter?: MTFiltersValuesI,
    sort?: MTSort,
    dir?: SortDirection,
    tab?: MinerTabType
  ): Promise<void | MinerRecordsResponse<IAdminMinerTableWithUnknown>> => {

    const query = isAdmin ? GetAdminMinersList : GetUserMinersList;

    if (
      (filter?.f_instalation_date_less ?? 0) >
      (filter?.f_instalation_date_more ?? 0)
    )
      return;
    const res = await enqueue<MinerRecordsResponse<IAdminMinerTableOrig>>(
      new query(offset, limit, filter, sort, dir, tab)
    );
    if (res?.Records === undefined) return undefined;
    if (!res.Namedtotals) res.Namedtotals = { ...EmptyNamedTotals };
    if (res.Total === undefined) {
      if (tab !== undefined) {
        res.Total = res.Namedtotals[tab];
      } else {
        res.Total = 0;
      }
    }
    if (tab !== "unknown") {
      return res as MinerRecordsResponse<IAdminMinerTable>;
    }
    const ress = res as MinerRecordsResponse<IUnknownMinerOrig>;
    const result: MinerRecordsResponse<IUnknownMiner> = {
      ...ress,
      Records: [],
    };
    for (const rec of ress.Records) {
      const r = JSON.parse(rec.description) as UnknownMinerDescr;
      result.Records.push({
        id: rec.id,
        created: moment(r.created),
        login: r.login,
        agent: r.agent,
        ip: r.ip,
        mac: r.mac ?? "",
      });
    }
    return result;
  };

  return { getMinerList };
};

export default useGetMinerList;
